import { apiBaseURL } from "../ProjectConstants";

async function handlePostDenyOrder(comment, orderId, fetch) {
  const response = await fetch.post(
    `${apiBaseURL}/api/Approval/Deny?orderId=${orderId}&comment=${comment}`,
  );
  const isDataGood =
    response?.success &&
    response?.data?.statusCode &&
    response?.success !== "Invalid Model";
  //   console.log("handlePostDenyOrder: orderId, comment", orderId, comment);
  //   console.log("handlePostDenyOrder response", response);

  return {
    response,
    isDataGood,
  };
}
export default handlePostDenyOrder;
